import SlimSelect from 'slim-select'

function multiSelect() {
  document.querySelectorAll('.multi-select').forEach((el) => {
    // Destroy if already initialized (to avoid duplicates after Turbo reloads)
    if (el.slim) {
      el.slim.destroy()
    }

    new SlimSelect({
      select: el,
      settings: {
        placeholderText: 'Select options'
      }
    })
  })
}

// Re-apply on Turbo lifecycle
document.addEventListener("turbo:load", multiSelect)
document.addEventListener("turbo:render", multiSelect)
document.addEventListener("turbo:frame-load", multiSelect)
